import { render, staticRenderFns } from "./DetailDPage.vue?vue&type=template&id=653202ce&scoped=true&"
import script from "./DetailDPage.vue?vue&type=script&lang=js&"
export * from "./DetailDPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailDPage.vue?vue&type=style&index=0&id=653202ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653202ce",
  null
  
)

export default component.exports